import styled from 'styled-components';

export const ListingFiltersWrapper = styled.div`
  margin: 20px 0;
  width: 260px;

  /* custom styles on the checkbox inside the filters */
  .checkbox-title {
    font-size: 14px;
    color: ${({ theme }) => theme.palette.brownishGrey};
    flex: 1;
    height: 100%;

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      width: 100%;
    }
  }
  .checkbox-sub-title {
    color: rgba(99, 99, 99, 0.6);
  }
`;

export const StyledSingleSelectionFilterWrapper = styled.div`
  width: 100%;
  height: 48px;
  padding: 16px 12px;
  background-color: ${({ theme }) => theme.palette.white};
  margin-bottom: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
`;

export const StyledMultiSelectionFilterWrapper = styled.div`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  margin-bottom: 20px;
`;

export const StyledPriceRangeFilterWrapper = styled.div`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  margin-bottom: 20px;
`;

export const StyledNameFilterWrapper = styled.div`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  margin-bottom: 20px;
`;

export const StyledExpediaPointFilterWrapper = styled.div`
  width: 100%;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.white};
  margin-bottom: 20px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const StyledHotelClassFilter = styled.div`
  padding: 12px;
  background-color: ${({ theme }) => theme.palette.white};
  margin-bottom: 20px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    border-radius: 8px;
  }
`;
